import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'ch-loading-button',
  templateUrl: './loading-button.component.html',
  styleUrls: ['./loading-button.component.css'],
})
export class LoadingButtonComponent implements OnInit {
  @Input() public text: string;
  @Input() public className: string;
  @Input() public loading: boolean;
  @Input() public disabled: boolean;
  @Output() public onClick: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  public clicked(event) {
    this.onClick.emit();
  }

  get targetClass() {
    return 'string' === typeof this.className && '' !== this.className.trim() ? this.className : 'btn btn-primary';
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/loading-button/loading-button.component.ts